import './style.scss';
import { checkStatusLabel } from '../../orderStatus/function/createBodyShowList';
import { formatNumber } from 'views/utils/format/FormatNumber';

export type CreateOrderDetailProps = {
  Status: number;
  SymbolName: string;
  TotalApplicationQuantity: number;
  TotalPurchaseQuantity: number;
  LatestApplicationDateTime: string;
};

export const createOrderDetail = (data: CreateOrderDetailProps) => {
  if (!data) return <div></div>;
  return (
    <div className="detailHeader">
      <div className="detailHeader_label">{checkStatusLabel(data.Status)}</div>
      <span className="detailHeader_name">{data.SymbolName}</span>
      <span className="detailHeader_amount">{`${formatNumber(Number(data?.TotalApplicationQuantity))} / ${formatNumber(
        Number(data?.TotalPurchaseQuantity),
      )} 口`}</span>
      <span className="detailHeader_date">{data.LatestApplicationDateTime}</span>
    </div>
  );
};
